import env from './lib/env.js'
import * as Ajax from './lib/ajax'
import * as Model from './lib/models'
import * as util from './lib/util.js'
import Color from './lib/color.js'
import Latex from './lib/latex.js'
import activityFactory from './lib/activity_factory.js'

const Util = util
Util.Latex = Latex
Util.Color = Color
Util.activityFactory = activityFactory

const version = require('./package.json').version

export {
  Ajax,
  Model,
  Util,
  env,
  version
}
